function SpinnerFullPage() {
  return <div>Loading...</div>;
}

export default SpinnerFullPage;
